import React, { useMemo } from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';
import { findCIPayer, TpBankAccount } from 'services/thirdParty';
import { isNil, noop } from 'lodash';

export type CIPayerSelectProps = SelectProps<any> & {
  tpid: string;
  isCreate?: boolean;
  ctrid?: number;
  allowClear?: boolean;
  selectedPayer?: number;
  onSelected?: (bf: any) => void;
};

const CIPayerSelect = ({
  tpid,
  isCreate,
  allowClear,
  selectedPayer,
  value,
  ctrid,

  onChange = noop,
  onSelected,
  ...props
}: CIPayerSelectProps) => {
  const params = useMemo(
    () => ({
      tpid: Number(tpid),
      role: 'CLIENT',
      ctrid: ctrid,
    }),
    [ctrid, tpid]
  );

  const { data, isFetching } = useQuery(
    ['findCIPayer', params],
    () => findCIPayer(params),
    {
      enabled: !isNil(tpid) && !isNaN(Number(tpid)),
      staleTime: MINUTE,
    }
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option: any) => {
    onChange(value, option);

    if (onSelected) {
      onSelected(
        data?.list?.find((item) => item.tpid === Number(option?.key))!
      );
    }
  };

  return (
    <Select
      allowClear={allowClear}
      value={!isNaN(value) ? Number(value) : value}
      onChange={handleChange}
      loading={isFetching}
      {...props}
    >
      {data?.list
        ?.find((tp) => tp.tpid === Number(tpid))
        ?.tpbklist?.map((beneficiary: TpBankAccount, index) => (
          <Select.Option value={beneficiary.tpbkid} key={index}>
            {beneficiary.tpbankname + ' - ' + beneficiary.tpiban}
          </Select.Option>
        ))}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default CIPayerSelect;
